// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import LOGOUT_CONSTANTS from '@tcp/core/src/components/features/account/Logout/LogOut.constants';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '@tcp/core/src/utils/cache.util';
import constants from '../Orders.constants';

const initialState = fromJS({
  [DEFAULT_REDUCER_KEY]: null,
  ordersList: null,
  isFetching: false,
  isLoadMoreActive: false,
  recentOrderDetails: null,
  accountDrawerOrdersList: null,
  isAccountDrawerOrdersFetching: false,
  isOrderLoading: true,
  selectedYear: null,
  pageNum: 0,
  modalState: false,
  companyId: null,
  isOrderError: null,
});

// eslint-disable-next-line complexity
const OrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SHOW_LOADER:
    case constants.GET_ORDERS_LIST:
      return state.set('isFetching', true);
    case constants.SET_NEW_LOADER:
      return state.set('isOrderLoading', action.payload);
    case constants.SET_ORDERS_LIST:
      return state.set('ordersList', action.payload);
    case constants.SET_ORDERS_LIST_STORE:
      return state.set('ordersListForStore', action.payload);
    case constants.SET_DELIVER_ORDERS_IDs:
      return state.set('deliveredOrderIds', action.payload);
    case constants.SHOW_CTL_LOADER:
      return state.set('isDeliveredFetching', true);
    case constants.HIDE_CTL_LOADER:
      return state.set('isDeliveredFetching', false);
    case constants.SET_CHANGED_SITEID:
      return state.set('changedSiteId', action.payload);
    case constants.HIDE_LOADER:
      return state.set('isFetching', false);
    case constants.HIDE_LOAD_MORE:
      return state.set('isLoadMoreActive', false);
    case constants.SHOW_LOAD_MORE:
      return state.set('isLoadMoreActive', true);
    case constants.SET_RECENT_ORDERDETAILS:
      return state.set('recentOrderDetails', action.payload);
    case constants.SHOW_ACCOUNT_DRAWER_ORDERS_LOADER:
      return state.set('isAccountDrawerOrdersFetching', true);
    case constants.HIDE_ACCOUNT_DRAWER_ORDERS_LOADER:
      return state.set('isAccountDrawerOrdersFetching', false);
    case constants.SET_SELECTED_ORDERS_YEAR:
      return state.set('selectedYear', action.payload);
    case constants.SET_PAGINATION:
      return state.set('pageNum', action.payload);
    case constants.TOGGLE_FILTER_MODAL:
      return state.set('modalState', action.payload);
    case constants.SET_COMPANY_ID:
      return state.set('companyId', action.payload);
    case constants.SET_FILTER_OPTIONS:
      return state.set('orderFilterOptions', action.payload);
    case constants.SET_ORDER_ERROR:
      return state.set('isOrderError', action.payload);
    case constants.SET_ACCOUNT_DRAWER_ORDERS_LIST:
      return state
        .set(
          DEFAULT_REDUCER_KEY,
          setCacheTTL(action.payload.cacheTTL || constants.DEFAULT_ACCOUNT_DRAWER_ORDERS_CACHE_TTL)
        )
        .set('accountDrawerOrdersList', action.payload.orders)
        .set('isAccountDrawerOrdersFetching', false);
    case constants.CLEAR_ACCOUNT_DRAWER_ORDERS_LIST:
      return state.set(DEFAULT_REDUCER_KEY, null);
    case LOGOUT_CONSTANTS.LOGOUT_APP:
      return initialState;
    default:
      // TODO: currently when initial state is hydrated on browser, List is getting converted to an JS Array
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default OrdersReducer;
